<script setup lang="ts">
  // Idioma
  const { locale, t } = useI18n()

  // Layout
  definePageMeta({
    layout: 'simple'
  })

  // Login redirect logic
  const { handleLoginSuccess } = useLoginRedirect()

  // Toast para mostrar errores
  const toast = useToast()
  const route = useRoute()

  // Verificar si hay error de Facebook email en la URL
  onMounted(() => {
    if (route.query?.error === 'facebook_email_required') {
      toast.add({
        title: t('errors.login.facebook_email_required'),
        color: 'error',
        icon: 'i-heroicons-exclamation-triangle'
      })
    }
  })

</script>

<template>
  <div class="w-full p-10">
    <div class="max-w-sm mx-auto flex flex-col gap-10">

      <h1 class="text-4xl text-center">{{ t('labels.login.title') }}</h1>

      <LoginForm 
        @login-success="() => handleLoginSuccess()"
      />

    </div>
  </div>
</template>